import React from 'react';
/**@type {React.Context<import('../../types').IPageData>} */

const pageDataContext = /*#__PURE__*/React.createContext(undefined);

function _PageDataContainer(_ref) {
  let {
    children,
    data
  } = _ref;
  const memoizedData = React.useMemo(() => data, [data]);
  return /*#__PURE__*/React.createElement(pageDataContext.Provider, {
    value: memoizedData
  }, children);
}

function usePageData() {
  const ctx = React.useContext(pageDataContext);

  if (!ctx) {
    throw new Error('usePageData must be used within a PageDataContainer');
  }

  return ctx;
}

const PageDataContainer = /*#__PURE__*/React.memo(_PageDataContainer);
export { PageDataContainer, usePageData };